import React from "react";

export const triangle = () => {
  return (
    <svg
      width="100%"
      height="42"
      viewBox="0 0 49 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.5 0L48.3157 41.25H0.684301L24.5 0Z" fill="currentColor" />
    </svg>
  );
};
